'use client'

import { PropsWithChildren, createContext, useContext, useState } from 'react'
import { ReferralCareOption } from '@/types/interfaces/referral-care-option'
import { ExternalLocation } from '@/types/interfaces/external-location'
import useSessionStorage from '@/hooks/useSessionStorage'

interface AppointmentRequestContextData {
    careActionId: string | null
    setCareActionId: (careActionId: string | null) => void
    selectedCareOption: ReferralCareOption | null
    setSelectedCareOption: (care_option: ReferralCareOption | null) => void
    selectedLocation: ExternalLocation | null
    setSelectedLocation: (location: ExternalLocation | null) => void
    selectedAvailability: string | null
    setSelectedAvailability: (availability: string) => void
    availabilityDetails: string | null
    setAvailabilityDetails: (details: string) => void
}

const AppointmentRequestContext = createContext<AppointmentRequestContextData>({
    careActionId: null,
    setCareActionId: () => undefined,
    selectedCareOption: null,
    setSelectedCareOption: () => undefined,
    selectedLocation: null,
    setSelectedLocation: () => undefined,
    selectedAvailability: null,
    setSelectedAvailability: () => undefined,
    availabilityDetails: null,
    setAvailabilityDetails: () => undefined,
})

export default function AppointmentRequestProvider({ children }: PropsWithChildren) {
    const [careActionId, setCareActionId] = useSessionStorage<string | null>('careActionId', null)
    const [selectedCareOption, setSelectedCareOption] = useSessionStorage<ReferralCareOption | null>(
        'selectedCareOption',
        null,
    )
    const [selectedLocation, setSelectedLocation] = useSessionStorage<ExternalLocation | null>('selectedLocation', null)
    const [selectedAvailability, setSelectedAvailability] = useState<string | null>('Soonest available')
    const [availabilityDetails, setAvailabilityDetails] = useState<string | null>(null)

    return (
        <AppointmentRequestContext.Provider
            value={{
                selectedCareOption,
                setSelectedCareOption,
                careActionId,
                setCareActionId,
                selectedLocation,
                setSelectedLocation,
                selectedAvailability,
                setSelectedAvailability,
                availabilityDetails,
                setAvailabilityDetails,
            }}
        >
            {children}
        </AppointmentRequestContext.Provider>
    )
}

export const useAppointmentRequestContext = () => useContext(AppointmentRequestContext)
